<template>
  <section class="geomagnetic-info">
    <h5>---地磁上报信息---</h5>
    <el-table class="geomagnetic-table" :data="geomagneticInfo" border>
      <el-table-column prop="devSn" label="地磁编号"></el-table-column>
      <el-table-column prop="type" label="地磁类型"></el-table-column>
      <el-table-column label="泊位号">
        <template slot-scope="scope">
          {{ scope.row.spaceId ? JSON.parse(scope.row.spaceId).spaceNum : "" }}
        </template>
      </el-table-column>
      <el-table-column prop="crtTime" label="上报信号时间"></el-table-column>
      <!-- <el-table-column
        prop="geomagneticLongTime"
        label="服务接受时间"
 
      ></el-table-column> -->
      <el-table-column prop="content" label="上报事件"></el-table-column>
      <!-- <el-table-column
        prop="geomagneticLongTime"
        label="信号强度"
        width="180"
      ></el-table-column> -->
    </el-table>
  </section>
</template>
<script>
export default {
  name: "geomagnetic-info",
  props: {
    geomagneticInfo: {
      type: Array,
      default: () => {
        return [
          // {
          //   geomagneticTime: "123456789",
          //   geomagneticLongTime: "2018-09-05 14:36:27",
          //   serviceAcceptTime: "2018-09-05 14:36:27",
          //   geomagneticEvent: "1",
          //   geomagneticStrength: "1",
          // },
          // {
          //   geomagneticTime: "123456789",
          //   geomagneticLongTime: "2018-09-05 14:36:27",
          //   serviceAcceptTime: "2018-09-05 14:36:27",
          //   geomagneticEvent: "1",
          //   geomagneticStrength: "1",
          // },
        ];
      },
    },
   
  },
  watch:{
      geomagneticInfo:{
        handler(val){
          console.log("geomagneticInfo",val)
      },
      deep:true,
      immediate:true,
    }
    }
};
</script>
<style scoped>
.geomagnetic-info {
  padding-bottom: 20px;
  box-sizing: border-box;
}
h5 {
  padding: 10px 0;
  box-sizing: border-box;
  font-weight: bold;
}
</style>
